import { render } from "./GmxLabel.vue?vue&type=template&id=161eca94&scoped=true"
import script from "./GmxLabel.vue?vue&type=script&lang=js"
export * from "./GmxLabel.vue?vue&type=script&lang=js"

import "./GmxLabel.vue?vue&type=style&index=0&id=161eca94&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161eca94"]])

export default __exports__